class LoopingDivs {
	constructor(el, dir = -1, speed = 0.2) {
		this.el = el;
		this.elements = this.el.querySelectorAll('.l');
		this.perView = 4;
		this.lerp = { current: 0, target: 0 };
		this.interpolationFactor = 0.1;
		this.speed = speed;
		this.direction = dir; // -1 (to-left), 1 (to-right)
		this.el.style.cssText = `position: relative; display: inline-flex; white-space: nowrap;`;
		this.el.children[1].style.cssText = `position: absolute; left: ${100 * -this.direction}%;`;
		this.events();
		this.render();
		this.animationId = null;

		this.elements.forEach((e) => {
			e.style.width = `${(window.innerWidth / this.perView) * this.elements.length}px`;
		});
	}

	lerpFunc(current, target, factor) {
		return current * (1 - factor) + target * factor;
	}

	events() {
		// window.addEventListener('scroll', () => (this.lerp.target += this.speed * 5));
		window.addEventListener('resize', () => {
			window.cancelAnimationFrame(this.animationId);

			this.lerp.current = 0;
			this.lerp.target = 0;

			this.elements.forEach((e) => {
				e.style.width = `${(window.innerWidth / this.perView) * this.elements.length}px`;
			});

			this.render();
		});
	}

	animate() {
		this.lerp.target += this.speed;
		this.lerp.current = this.lerpFunc(
			this.lerp.current,
			this.lerp.target,
			this.interpolationFactor
		);

		if (this.lerp.target > 100) {
			this.lerp.current -= this.lerp.target;
			this.lerp.target = 0;
		}

		const x = this.lerp.current * this.direction;
		this.el.style.transform = `translateX(${x}%)`;
	}

	render() {
		this.animate();
		this.animationId = window.requestAnimationFrame(() => this.render());
	}
}

export const LogoGrid = (() => {
	'use strict';

	function init() {
		document
			.querySelectorAll('.loop-container')
			.forEach((el, idx) => new LoopingDivs(el, (idx + 1) % 2 === 0 ? 1 : -1, 0.05));
	}

	return {
		init: init,
		name: 'logo-grid',
	};
})();
